import { createContext, useContext, type ReactNode } from 'react';

const SnapshotPrintContext = createContext(false);

export function SnapshotPrintProvider({
  active,
  children,
}: {
  active: boolean;
  children: ReactNode;
}) {
  return (
    <SnapshotPrintContext.Provider value={active}>
      {children}
    </SnapshotPrintContext.Provider>
  );
}

/** True while Snapshot PDF is preparing — tables/charts expand for full export. */
export function useSnapshotPrint(): boolean {
  return useContext(SnapshotPrintContext);
}
